<a
    [class]="ymalClass >= 376 ? 'ymal-card' : 'ymal-card-clean'"
    [routerLink]="learningObject.routerLink"
>
    <div class="thumbnail">
        <app-language-badge [languages]="learningObject.languages"></app-language-badge>
        <app-resource-card-poster
            [posterImage]="learningObject.getPosterImage(269, 151)"
            [alt]="learningObject.getPosterImageAlt()"
            [duration]="learningObject.duration"
            [gtmPrefix]="gtmPrefix"
            [title]="learningObject.title"
            [absoluteUrl]="learningObject.canonicalUrl"
        >
        </app-resource-card-poster>
    </div>
    <div class="content">
        <a [class]="getResourceBodyClass()" [attr.data-gtmlabel]="learningObject.canonicalUrl">
            <app-card-title [height]="52" [rows]="isCardLarge() ? 2 : 10">{{
                learningObject.title
            }}</app-card-title>
        </a>
        <div
            class="content-project-name"
            *ngIf="learningObject.project && learningObject.project.title"
        >
            {{ learningObject.project.title | safeTruncate: 25 }}
        </div>

        <app-ymal-card-meta
            [ngClass]="{ 'move-down': !learningObject.project }"
            [mediaType]="learningObject.mediaType[0]"
            [supportMaterialsCount]="learningObject.supportMaterials.length"
            [supportMaterialsLink]="learningObject.routerLink"
        >
        </app-ymal-card-meta>
    </div>
</a>
